define.alias("shared/components/shared/ui/social-set-switcher/list", "preview-grid/components/shared/ui/social-set-switcher/list");